import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { UserController } from "services/user/UserController";
import { Button, Card, Input, Link } from "stories";
import { useFetchState } from "utils/customHooks/useFetchState";
import { z } from "zod";
import classes from "./SignInCard.module.scss";

const schema = z.object({
  email: z.string().email("Please enter a valid email"),
  password: z.string().min(1, "This field is required"),
});

const getDefaultValues = () => ({
  email: "",
  password: "",
});

export const SignInCard = () => {
  const {
    formState: { errors },
    ...form
  } = useForm({
    defaultValues: getDefaultValues(),
    resolver: zodResolver(schema),
  });
  const navigate = useNavigate();
  const user = UserController();
  const [fetchState, sendRequest] = useFetchState();
  const handleUserSignIn = (requestBody) => {
    sendRequest(user.createSession, requestBody);
  };

  useEffect(() => {
    if (!fetchState.isLoading && !fetchState.isError && fetchState.data) {
      localStorage.setItem("token", fetchState.data.token);
      navigate("/dashboard");
    }
  }, [fetchState, navigate]);
  return (
    <div className={classes["wrapper"]}>
      <Card>
        <div className={classes["content-wrapper"]}>
          <div className={classes["title"]}>Sign In</div>
          <form onSubmit={form.handleSubmit(handleUserSignIn)}>
            <Input
              label={"Email"}
              placeholder={"example@domain.com"}
              {...form.register("email")}
              error={errors?.email?.message}
            />
            <Input
              type={"password"}
              label={"Password"}
              placeholder={"Input password"}
              {...form.register("password")}
              error={errors?.password?.message}
            />
            <div className={classes["button-wrapper"]}>
              <Button label={"Sign In Now"} loading={fetchState.isLoading} />
              <div className={classes["link-wrapper"]}>
                <Link to={"/password/request"} inherit>
                  Reset Password
                </Link>
              </div>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};
